document.addEventListener('DOMContentLoaded', function(){

  document.querySelectorAll('.promo-banner-products').forEach(function(section){

    const slider = section.querySelector('.promo-products-slider');

    if(!slider) return;

    const flkty = new Flickity(slider,{
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true
    });

    const nextBtn = section.querySelector('.promo-next');
    const prevBtn = section.querySelector('.promo-prev');

    if(nextBtn){
      nextBtn.addEventListener('click', function(){
        flkty.next();
      });
    }

    if(prevBtn){
      prevBtn.addEventListener('click', function(){
        flkty.previous();
      });
    }

  });

});



document.addEventListener('DOMContentLoaded', function(){

  console.log('JS LOADED');

  document.querySelectorAll('.customer-testimonials').forEach(function(section){

    console.log('SECTION FOUND');

    const slider = section.querySelector('.testimonial-slider');

    console.log('SLIDER', slider);

    if(!slider) return;

    const flkty = new Flickity(slider,{
      cellAlign:'left',
      contain:true,
      pageDots:false,
      prevNextButtons:false,
      wrapAround:true,
      groupCells:'50%'
    });

    console.log('FLICKITY CREATED');

    const nextBtn = section.querySelector('.testimonial-next');
    const prevBtn = section.querySelector('.testimonial-prev');

    nextBtn?.addEventListener('click', function(){
      console.log('NEXT CLICK');
      flkty.next();
    });

    prevBtn?.addEventListener('click', function(){
      console.log('PREV CLICK');
      flkty.previous();
    });

  });

});